<template>
  <div>
    <multiselect
      v-model="post"
      :id="name"
      label="dd_o_label"
      track-by="dd_o_label"
      placeholder="Type to search"
      open-direction="bottom"
      :options="extra"
      :multiple="true"
      :searchable="true"
      :loading="isLoading"
      :limit-text="limitText"
      :max-height="600"
      :show-no-results="false"
      :hide-selected="true"
      group-values="value"
      group-label="group"
      @search-change="asyncFind"
      @input="send"
    >
      <template slot="option" slot-scope="props">

        <span v-if="props.option.$isLabel">{{ props.option.$groupLabel }}</span>
        <span v-else>
          {{ props.option.dd_o_label }} <br>
          <small v-if="dropdown_name == 'dd_prd_id'">
            Sku : {{ props.option.sku }} <br>
            Harga : Rp. {{ $root.numberWithCommas(props.option.purchase) }}
          </small>

        </span>
      </template>
    </multiselect>
  </div>
</template>

<script>
import { _ } from "vue-underscore";

export default {
  props: [
    "name",
    "validation",
    "content",
    "dropdown_name",
    "parsingTrigger",
    "parsingPostMulti",
    "search",
    "table_module",
  ],
  data() {
    return {
      post: this.content,
      extra: [],
      list: {},
      isLoading: false,
    };
  },
  mounted() {
    var result = [];
    for (const key in this.content) {
      const element = this.content[key].dd_o_value;
      result.push(element);
    }

    this.$emit("post", {
      name: this.name,
      value: result,
    });
  },
  methods: {
    limitText(count) {
      return ` ${count} item lainya`;
    },
    send(evt) {
      // var res = [];
      var result = [];
      for (const key in evt) {
        const element = evt[key].dd_o_value;
        result.push(element);
      }

      this.$emit("post", {
        name: this.name,
        value: result,
      });
    },
    asyncFind: _.debounce(function (query) {
      if (query.length == 0) {
        return false;
      }

      this.isLoading = true;
      var params = {};

      if (this.dropdown_name == "dd_prd_id") {
        params = {
          ["search[prd_name]"]: query,
        };

        params["input_type"] = "multiplegroup_autocomplete";
        if (typeof this.parsingPostMulti.crs_model_id !== "undefined") {
          params["filter[crs_model_id]"] = this.parsingPostMulti.crs_model_id;
        }
      }

      this.axios
        .get("/dropdown/autocomplete/" + this.dropdown_name, { params: params })
        .then((response) => {
          this.isLoading = false;
          this.extra = response.data.data;
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.status == 500) {
              console.log("error 500");
            }
          }
        });
    }, 500),
    clearAll() {
      this.post = [];
    },
  },
};
</script>